module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (12).f17d6402.svg";